import IMask from 'imask';

export default new class Input {
    constructor() {
        this.sPhoneInputClass = '[name="phone"]';
        this.sInnInputClass = '[name="inn"]';
        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {

            //маска для номера телефона
            this.initPhoneMask();
        });
    }

    initPhoneMask() {
        document.querySelectorAll(`${this.sPhoneInputClass}`).forEach((el) => {
            let mask = IMask(
                el,
                { mask: '+000 0000 0000 0000', /*lazy: false, placeholderChar: 'X'*/}
            );
        });
        document.querySelectorAll(`${this.sInnInputClass}`).forEach((el) => {
            let mask = IMask(
                el,
                { mask: '0000000000', /*lazy: false, placeholderChar: 'X'*/}
            );
        });
    }
}();